import { gql } from '@apollo/client';

export const LOGIN = gql`
    mutation Login($email: String!, $password: String!) {
        login(input: { email: $email, password: $password }) {
            kind
            registered
            localId
            email
            idToken
            refreshToken
            expiresIn
            approved
            userType
        }
    }
`;
export const LOGOUT = gql`
    mutation logout {
        logout {
            message
        }
    }
`;

export const SIGN_UP = gql`
    mutation signUp($input: SignUpInput!) {
        signUp(input: $input) {
            id
            creator
            created
            updater
            updated
            phone
            firstName
            lastName
            email
            userType
        }
    }
`;

export const CREATE_USER_IF_NOT_EXIST = gql`
    mutation createUserIfNotExist($input: CreateUserIfNotExistInput!) {
        createUserIfNotExist(input: $input) {
            id
            creator
            created
            updater
            updated
            phone
            firstName
            lastName
            email
            userType
        }
    }
`;

export const UPDATE_PROFILE = gql`
    mutation updateProfile($input: UpdateUserInput!) {
        updateProfile(input: $input) {
            id
            creator
            created
            updater
            updated
            phone
            firstName
            lastName
            userName
            email
            gender
            profileImageUrl
            modelImageUrl
            userType
            stylistExpertiseId
            preferredLanguage
            stylistExpertise {
                id
                title
                value
            }
            quizCompleted
            bodyFullFrontImage
        }
    }
`;
export const REFRESH_TOKEN = gql`
    mutation refreshToken($input: RefreshTokenInput!) {
        refreshToken(input: $input) {
            id_token
            access_token
            expires_in
            refresh_token
            token_type
            user_id
            project_id
        }
    }
`;
